<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90.07 90.07">
  <rect class="cls-2" x="10.21" y="33.72" width="21.18" height="29.94" rx="4.45" ry="4.45"/>
  <rect class="cls-2" x="34.45" y="23.58" width="21.18" height="40.09" rx="4.45" ry="4.45"/>
  <rect class="cls-2" x="58.69" y="13.35" width="21.18" height="50.32" rx="4.45" ry="4.45"/>
  <g>
    <path class="cls-1" d="m72.64,73.1H11.62c-.78,0-1.41-.64-1.41-1.43s.63-1.43,1.41-1.43h61.01c.78,0,1.41.64,1.41,1.43s-.63,1.43-1.41,1.43Z"/>
    <path class="cls-1" d="m72.05,76.63l7.47-4.36c.46-.27.46-.93,0-1.2l-7.47-4.36c-.46-.27-1.03.07-1.03.6v8.72c0,.53.57.87,1.03.6Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "EquivTableIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #0f5b71;
  }
  .cls-2 {
    fill: #59c5c7;
  }
</style>
